import { jsx as _jsx } from "react/jsx-runtime";
import { getInputFocusState } from '#pplx/frontend/composer-sdk/lexical/utils/inputFocusState.js';
import { composerStyles } from '#pplx/frontend/composer-sdk/styles.js';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { useLexicalEditable } from '@lexical/react/useLexicalEditable';
import classNames from 'classnames';
import { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
const COMPACT_HEIGHT = '1.5em';
export const ComposerContentEditable = forwardRef(function ComposerContentEditable({ id, minRows = 1, maxRows, compact = false, 'aria-label': ariaLabel, 'data-test-id': dataTestId, 'aria-placeholder': ariaPlaceholder = '', placeholder, }, ref) {
    const isEditable = useLexicalEditable();
    const editorElementRef = useRef(null);
    const inputElementClassNames = useMemo(() => classNames(...composerStyles.inputElement, 'composer-editable size-full min-w-0', !isEditable && 'cursor-not-allowed text-tertiary', compact && [
        '!break-normal',
        '!whitespace-nowrap',
        '[&_*]:!break-normal',
        '[&_*]:!whitespace-nowrap',
        '[&_p]:!m-0',
        'overflow-x-auto overflow-y-hidden whitespace-nowrap',
    ]), [compact, isEditable]);
    const style = useMemo(() => compact
        ? {
            height: COMPACT_HEIGHT,
            minHeight: COMPACT_HEIGHT,
            maxHeight: COMPACT_HEIGHT,
            overflowWrap: 'normal',
            overflowX: 'auto',
            overflowY: 'hidden',
        }
        : {
            minHeight: `${minRows * 1.5}em`,
            maxHeight: maxRows ? `${maxRows * 1.5}em` : undefined,
        }, [compact, maxRows, minRows]);
    // Lexical's ContentEditableProps is a discriminated union: either no placeholder, or both
    // aria-placeholder (string) and a non-null placeholder together.
    const placeholderProps = placeholder == null
        ? { placeholder: null }
        : { 'aria-placeholder': ariaPlaceholder, placeholder };
    useImperativeHandle(ref, () => ({
        getFocusState: () => getInputFocusState(editorElementRef.current),
    }), []);
    return (_jsx(ContentEditable, { className: inputElementClassNames, "aria-label": ariaLabel, "aria-disabled": isEditable ? undefined : true, "data-test-id": dataTestId, id: id, ref: editorElementRef, style: style, ...placeholderProps }));
});
//# sourceMappingURL=ComposerContentEditable.js.map